import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-age-verifiaction',
  templateUrl: './age-verifiaction.component.html',
  styleUrls: ['./age-verifiaction.component.css']
})
export class AgeVerifiactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
